import React from "react";
import { Card, CardContent } from "@/components/ui/card";

const ProcessSection: React.FC = () => {
  return (
    <section className="py-8 md:py-16 px-4 md:px-6 bg-background">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-6 md:mb-10">
          <p className="text-xs tracking-widest font-medium uppercase text-primary mb-2">
            CONHEÇA A EMPRESA
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
            Processos 100% administrativos
          </h2>
        </div>

        <Card className="shadow-sm">
          <CardContent className="p-4 md:p-6 space-y-4 text-muted-foreground leading-relaxed">
            <p>
              Uma das principais razões pelas quais a Tax Health se destaca no mercado é a nossa <strong className="text-foreground">abordagem personalizada e focada nas necessidades específicas de profissionais e empresas da área de saúde</strong>.
            </p>
            <p>
              Enquanto outras empresas possam oferecer soluções genéricas de redução de impostos, a Tax Health compreende as particularidades e desafios únicos enfrentados por médicos, clínicas, laboratórios e hospitais.
            </p>
            <p>
              Além disso, nossa equipe de especialistas está constantemente atualizada em relação à legislação tributária e às mudanças no mercado de saúde, garantindo que você sempre esteja em conformidade com as regras e regulamentos fiscais.
            </p>
            <p>
              Enquanto profissionais e empresas sem o apoio da Tax Health continuam pagando impostos em excesso e perdendo oportunidades de economia, nossos clientes <strong className="text-foreground">desfrutam de benefícios fiscais significativos</strong>, obtendo um fluxo de caixa mais saudável e uma maior lucratividade para seus negócios.
            </p>
            <p>
              Não deixe que a alta carga tributária impeça o crescimento e o sucesso de sua prática ou empresa na área de saúde. Entre em contato com a Tax Health hoje mesmo e descubra como podemos ajudá-lo a economizar dinheiro, recuperar impostos pagos em excesso e alcançar a prosperidade que você merece.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ProcessSection;
